<div class="file-drag-drop" (drop)="onDrop($event)" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)">
  <div class="box-input">
    <img class="mb-16 upload-img" [src]="uplaodImg"/>
    <div class="box-label">
      <p class="box-label-title">{{message}}</p>
      <p class="box-label-subtitle" *ngIf="fileName">{{fileName}}</p>
    </div>
    <label class="file-input" *ngIf="!showOnUploadAttempt">
      <span class="browse" [innerHTML]="browseLabel"></span>
      <input #fileUpload class="box-file" accept='.xls' type="file" (change)="onFileSelected($event)"/>
    </label>
    <label class="file-input" *ngIf="showOnUploadAttempt" (click)="openModal()">
      <span class="file-info-message" [innerHTML]="browseLabel"></span>
    </label>
  </div>
</div>

